import React, { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, useWindowDimensions, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import { Image } from 'expo-image';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Community, CommunityInfo } from '@/types/community';
//import { StackedBarChart } from "react-native-chart-kit-rabbl";
//import { AbstractChartConfig } from 'react-native-chart-kit-rabbl/dist/AbstractChart';
import * as AppConsts from '@/utilities/AppConsts';
import { AppText } from '@/components/AppText';
import { CustomDivider } from '@/components/CustomDivider';
import SvgChart, { SVGRenderer } from '@wuba/react-native-echarts/svgChart';
import * as echarts from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components';
import rabbl_stats from "@/data/rabbl_stats.json";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "90%",
    gap: 20,
    alignItems: 'center',
    alignSelf: 'center',
  },
  wrapper: {
    gap: 10,
  },
  seemap: {
    width: 225,
    height: 225,
  },
  indent: {
    paddingLeft: 20,
  },
  underline: {
    textDecorationLine: "underline",
  },
  totalMembersWrapper: {
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
  },
  w15h10: {
    width: 15,
    height: 10,
  },
  w18h15: {
    width: 18,
    height: 15,
  },
  membersWrapper: {
    flexDirection: "row",
    paddingLeft: 20,
    gap: 8,
    alignItems: "center",
  },
});

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  SVGRenderer,
  BarChart,
  LineChart,
  LegendComponent,
]);

function subtractOneMonth(date: Date) : void {
  const currentDay = date.getDate();

  // Set to the 1st first to avoid accidental multi-month hops during transitions
  date.setDate(1);
  date.setMonth(date.getMonth() - 1);

  // Find the max days in the new month
  const maxDays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

  // Set back the original day or clip it to the month's maximum
  date.setDate(Math.min(currentDay, maxDays));
}

const titles: string[] = [];

let d = new Date();
titles.unshift(d.toLocaleString('default', { month: 'short' }));

subtractOneMonth(d);

titles.unshift(d.toLocaleString('default', { month: 'short' }));

const MAX_WIDTH = 250;

function getChartWidth(screenWidth: number) {
  let result = screenWidth;
  if (result > MAX_WIDTH) {
    result = MAX_WIDTH;
  }
  //if (result > 100) {
  //  result -= 60;
  //}
  return result;
}

/*
const colorMode : string = 'light';


const stackedChartConfig : AbstractChartConfig = {
  backgroundColor: colorMode === "dark" ? "#000000" : "#c6c6c6",
  backgroundGradientFrom: colorMode === "dark" ? "#000000" : "#c6c6c6",
  backgroundGradientTo: colorMode === "dark" ? "#000000" : "#c6c6c6",
  //backgroundColor: colorMode === "dark" ? "#000000" : "#ffffff",
  //backgroundGradientFrom: colorMode === "dark" ? "#000000" : "#ffffff",
  //backgroundGradientTo: colorMode === "dark" ? "#000000" : "#ffffff",
  decimalPlaces: 0,
  color: (opacity = 1) => `rgba(59, 130, 246, ${opacity})`,
  //labelColor: (opacity = 1) => `rgba(107, 114, 128, ${opacity})`,
  labelColor: (opacity = 1) => '#000000',
  style: {
    borderRadius: 16,
  },
  propsForDots: {
    r: "4",
    strokeWidth: "2",
    stroke: "#3b82f6",
  },
  propsForBackgroundLines: {
    strokeDasharray: "",
    stroke: `rgba(255, 255, 255,0.3)`,
    strokeWidth: 1,
  },
};

const renderLegend = (text: string, color: string) : React.ReactNode => {
  return (
    <View style={{flexDirection: 'row', marginBottom: 12}}>
      <View
        style={{
          height: 18,
          width: 18,
          marginRight: 5,
          borderRadius: 4,
          backgroundColor: color || 'white',
        }}
      />
      <AppText>{text}</AppText>
    </View>
  );
};

function getMaxValue(data: number[][]) : number {
  let max = 1;
  data.forEach((values) => {
    if (values[0] > max) {
      max = values[0];
    }
    if (values[1] > max) {
      max = values[1];
    }
  });
  return max;
}
  */

interface Props {
  community: Community,
  community_info: CommunityInfo,
  admin?: boolean,
  showMap?: boolean,
};

interface MonthsChartOptions {
  width: number,
  height: number,
  options: any,
  data: number[][],
};

function RecentMonthsChart({ width, height, data, options } : MonthsChartOptions) {
  const chartRef = useRef<any>(null);

  useEffect(() => {
    let chart: any = undefined;
    if (chartRef.current) {
      chart = echarts.init(chartRef.current, 'light', {
        renderer: 'svg',
        width: width,
        height: height,
      });
      const menData = [];
      const womenData = [];
      const totalData = [];
      for (const dataPiece of data) {
        totalData.push(dataPiece[0] + dataPiece[1]);
        womenData.push(dataPiece[0]);
        menData.push(dataPiece[1]);
      }
      for (const series of options.series) {
        if (series.name == "Women") {
          series.data = womenData;
        } else if (series.name == "Men") {
          series.data = menData;
        } else if (series.name == "Total") {
          series.data = totalData;
        }
      }
      
      chart.setOption(options);
    }
    return () => chart?.dispose();
  }, [options]);

  return <SvgChart ref={chartRef} />;

  /*return (
    <StackedBarChart
      data={{
        labels: titles,
        legend: ["Women", "Men"],
        data: data,
        barColors: [AppConsts.COLOR2, AppConsts.COLOR1]
      }}
      width={getChartWidth(width)}
      height={220}
      chartConfig={stackedChartConfig}
      style={{
        marginVertical: 8,
        borderRadius: 16,
        //marginLeft: -30,
      }}
      hideLegend={false}
      segments={4}
    />
  );*/
}

export function RabblStats({ community, community_info, admin = false, showMap = true }: Props) : React.ReactNode {
  const { width } = useWindowDimensions();

  // https://echarts.apache.org/en/option.html#title
  // https://echarts.apache.org/examples/en/editor.html?c=bar-y-category-stack&code=nVKxbsIwEN37FZY6eMlQukHVgbGVqlYqaoeK4SBHsGR8yHaAqOLfe45DYggZSobYPt977-6eaesVGfEsfu8Ef55Ie7WdNEcOWFUUaCdCwkE5mTXhcPggZXy4OuVydrVFTl1acl2uEPX501eaL7tkjpOmQH0_Ho9lGz82u7geI00obEGHDr9C8KU9I8zBw5fCPceEWxOv3paYCYuQvxtdTcQKtMMTZfg2UKjlrK76HBM7-ZFaGZSZkAuwcp4iLTpPtX6CSxMc7HDqXlihl3StQY0FmrxrJzQTCnhDE_S_aRM3M_Kg5TyFHqbsBuc2yL4d4LEgWyWOnNhfSx1Ip2Uh593tgLstoVtDTvshxxqiKlbVPqQI3YEueaBp-Q6twqv1G9gETD2Cy6aCIb1-klJHmRi1xziuVvGKRjPfG1Qe_qESzeupxEd2KfPIHSSmaFigPreje1NDVvD_-PQH&enc=deflate
  // https://echarts.apache.org/examples/en/index.html
  // https://echarts.apache.org/examples/en/editor.html
  const option = Object.assign({}, rabbl_stats);
  option.xAxis[0].data = titles;
  option.series[0].itemStyle.color = AppConsts.MAIN_COLOR1;
  option.series[1].itemStyle.color = AppConsts.MAIN_COLOR2;
  option.series[2].itemStyle.color = AppConsts.COLOR8;

  return (
    <View style={styles.wrapper}>
      <CustomText>Members</CustomText>
      <View style={{ gap: 20, paddingVertical: 20 }}>
        <View style={styles.totalMembersWrapper}>
          <Image source={require('@/assets/images/minis/heartsbounce.gif')} style={styles.w15h10} />
          <AppText>
            <AppText style={[styles.underline, CustomTextStyles.highlight]}>Total:</AppText>  {community.members_total}
          </AppText>
        </View>
        <View style={styles.membersWrapper}>
          <Image source={require('@/assets/images/minis/bird5.gif')} style={styles.w18h15} />
          <AppText>
            <AppText style={CustomTextStyles.highlight}>Women:</AppText>  {community.members_women}
          </AppText>
        </View>
        <View style={styles.membersWrapper}>
          <Image source={require('@/assets/images/minis/bird4.gif')} style={styles.w18h15} />
          <AppText>
            <AppText style={CustomTextStyles.highlight}>Men:</AppText>  {community.members_men}
          </AppText>
        </View>
      </View>
      {
        !admin && community.members_total == 0 && (
          <AppText>
            There aren't any members yet but you can get notified when new people join after you sign up.
          </AppText>
        )
      }
      <View style={AppConstants.STYLES.alignCenter}>

        {
          showMap && community.members_total > 0 && (
            <>
              <Link href="/map" asChild={AppUtilities.isWeb()}>
                <Image
                  source={require('@/assets/images/seemap.png')}
                  style={styles.seemap}
                />
              </Link>
            </>
          )
        }

        {width > 0 && (
          <>
            <CustomDivider fullWidth={true} marginBottom={true} marginTop={true} />
            <CustomText>Monthly Trend</CustomText>
            <RecentMonthsChart width={getChartWidth(width)} height={300} options={option} data={community_info.member_counts} />
            {/*<View
              style={{
                alignSelf: 'center',
                paddingBottom: 20,
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                gap: 10,
              }}>
              {renderLegend('Men', AppConsts.COLOR1)}
              {renderLegend('Women', AppConsts.COLOR2)}
              {renderLegend('Total', AppConsts.COLOR8)}
            </View>*/}
          </>
        )}

        { /*
        <View
          style={{
            alignSelf: 'flex-start',
            paddingLeft: 20,
            paddingBottom: 20,
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            marginTop: 20,
            gap: 20,
          }}>
          {renderLegend('Women', AppConsts.COLOR2)}
          {renderLegend('Men', AppConsts.COLOR1)}
        </View>

        //https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/BarChart/BarChartProps.md
        <BarChart
          width={150}
          //rotateLabel={true}
          noOfSections={2}
          stackData={
            community_info.member_counts.map((month_data, index) => {
              return {
                stacks: [
                  {value: month_data[0], color: AppConsts.COLOR2, marginBottom: 2},
                  {value: month_data[1], color: AppConsts.COLOR1, marginBottom: 2},
                ],
                label: titles[index],
              };
            })
          }
          showValuesAsTopLabel={true}
          //showLine={true}
          maxValue={getMaxValue(community_info.member_counts)}
          yAxisExtraHeight={200}
          formatYLabel={(x) => {
            if (x == "0.5") {
              return "";
            }
            const y = Number(x);
            return new Intl.NumberFormat(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0
            }).format(y);
          }}
        />*/ }
      </View>
    </View>
  );
};
